var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9943 18.5H20.0168C20.5622 18.5 21.0164 18.0598 20.9285 17.5216C20.8079 16.7835 20.5365 16.0746 20.1276 15.4405C20.1015 15.4001 20.0721 15.3617 20.0389 15.327C19.1495 14.3961 17.4955 14.2523 16.6513 13.5898C16.2784 13.2971 16.4937 12.7875 16.8439 12.468C17.0933 12.2405 17.3086 11.9762 17.4818 11.6831C17.7937 11.1552 17.9573 10.553 17.9554 9.94005C17.9728 9.49956 17.902 9.06005 17.747 8.64729C17.592 8.23453 17.356 7.85685 17.0529 7.53642C16.7498 7.21598 16.3857 6.95924 15.9819 6.78128C15.5781 6.60331 15.1428 6.5077 14.7015 6.50005C14.2975 6.48997 13.8939 6.53028 13.5 6.62005",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 15.56C14.7444 14.2704 13.073 14.1494 12.2462 13.2252C11.9298 12.8715 12.1581 12.3658 12.5234 12.0628C12.9024 11.7484 13.2256 11.3692 13.4767 10.9408C13.8659 10.2768 14.0675 9.51962 14.06 8.75C14.076 8.20758 13.985 7.66733 13.792 7.16013C13.5991 6.65292 13.3082 6.1887 12.9358 5.79401C12.5633 5.39931 12.1168 5.08187 11.6217 4.85984C11.1265 4.63781 10.5925 4.51553 10.05 4.5C8.95717 4.53657 7.92317 5.00401 7.17375 5.80027C6.42433 6.59653 6.02036 7.65694 6.05002 8.75C6.04369 9.51819 6.24471 10.2739 6.6319 10.9374C6.88223 11.3663 7.20438 11.7465 7.58244 12.0623C7.94509 12.3652 8.1701 12.869 7.85317 13.2195C7.00628 14.156 5.26576 14.2848 4.13002 15.52C3.43185 16.3214 3.16491 17.6167 3.06293 18.5108C3.00068 19.0566 3.44318 19.5 3.99253 19.5H16.0223C16.5658 19.5 17.0062 19.0656 16.952 18.5248C16.8626 17.634 16.6112 16.3405 15.91 15.56Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.273c9773a1d50f23bd33b2feb69b27f2.svg";
export { ForwardRef as ReactComponent };